/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AboutInputs */



/**
* | output |
* | --- |
* | "About" |
*
* @param {AboutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const about = /** @type {((inputs?: AboutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AboutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("À propos")
	if (locale === "de") return /** @type {LocalizedString} */ ("Um")
	if (locale === "it") return /** @type {LocalizedString} */ ("Di")
	if (locale === "ru") return /** @type {LocalizedString} */ ("О")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acerca de")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关于")
	if (locale === "ja") return /** @type {LocalizedString} */ ("について")
	if (locale === "hi") return /** @type {LocalizedString} */ ("के बारे में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobre")
	return /** @type {LocalizedString} */ ("About")
});